import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'
import useGetTeams from './useGetTeams'

export default function useGetTeamDetails({
  teamId,
}: {
  teamId: string | undefined
}) {
  const { data: teams, promise } = useGetTeams()

  const fetchData = async () => {
    const response = await httpClient.get(`team/team/details`, {
      headers: {
        ...(teamId ? { 'X-Team': teamId } : {}),
      },
    })

    return response.data
  }

  return useQuery({
    queryKey: ['team-details', teamId],
    queryFn: fetchData,
    staleTime: Infinity,
  })
}
